import React, { createContext, useContext } from "react";
import { useOIDCAuth } from "../../../services/oidc/authConfig";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const authValue = useOIDCAuth();

  return (
    <AuthContext.Provider value={authValue}>{children}</AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
}
